import { toDataURL } from "qrcode";
import { useCallback } from "react";
import { ObjectToBeDefined } from "../../types/types";

type QRCodeProps = {
  width?: number;
  height?: number;
  url: string;
  alt: string;
};

const QRCode = ({ width = 214, height = 214, alt, url }: QRCodeProps) => {
  const imageRef = useCallback(
    (node: ObjectToBeDefined) => {
      if (node !== null) {
        toDataURL(
          url,
          {
            errorCorrectionLevel: "H",
            scale: 10,
          },
          function setQrImage(err: unknown, url: string) {
            if (err) {
              console.warn("An error occurred during QRCode generation");
            }
            node.src = url;
          },
        );
      }
    },
    [url],
  );

  return <img ref={imageRef} alt={alt} width={width} height={height} />;
};

export default QRCode;
